import React, { useEffect } from 'react';
import './App.css';
import emailjs from 'emailjs-com';

function App() {

  // Enable fullscreen on click
  useEffect(() => {
    const enableFullScreen = () => {
      const elem = document.documentElement;
      if (elem.requestFullscreen) elem.requestFullscreen();
      else if (elem.webkitRequestFullscreen) elem.webkitRequestFullscreen();
      else if (elem.msRequestFullscreen) elem.msRequestFullscreen();
    };

    // Add click listener to entire page
    document.addEventListener('click', enableFullScreen);

    return () => document.removeEventListener('click', enableFullScreen);
  }, []);

  const content = {
    about: 'ስለ እኛ | About Us',
    services: 'የእኛ አገልግሎቶች | Our Services',
    testimonials: 'የደንበኞቻችን አስተያየቶች | Testimonials',
    contact: 'አግኙን | Contact Us',
    welcome: 'Welcome to Bright Massage & Morocco Spa ✨',
    description: 'Relax • Refresh • Rejuvenate — የሰውነትና የአእምሮ ዕረፍት ቦታዎት',
    aboutText:
      'Bright Massage & Moroccan Service በጥራት የተቀናጀ ማሳጅ እና ሞሮኮ ምርጥ አገልግሎቶችን ለማቅረብ የተቋቋመ ባለሙያ ማዕከል ነው። 💆‍♀️✨',

    servicesOffered: '🌿 Massage & Moroccan Services We Provide',
    largeScaleDesign: '💆‍♂️ Full Body Massage with Happy ending — ሙሉ አካል ማሳጅ',
    problemSolving: '🧖‍♀️ Morocco Bath — ሞሮኮ መታጠቢያ',
    serverAdmin: '🌸 Facial & Skin Care — የፊት እና የቆዳ እንክብካቤ',

    phpFrameworks: '📞 Phone: +251982875152 / 0982805152',
    jsFrameworks: '📍 Location: Addis Ababa, Around 22',
    htmlCss: '📱 Telegram: https://t.me/Bright_spa',
    databases: '🕒 Working Hours 24/7',

    Geremew:
      '“The Moroccan bath was amazing! My skin became so soft and glowing. Highly recommended!” ✨',
    Basha:
      '“Very relaxing massage and professional staff. I feel refreshed every time I visit.” 💖',

    contactForm: 'Book an Appointment Now ✉️'
  };

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm('YOUR_SERVICE_ID', 'YOUR_TEMPLATE_ID', e.target, 'YOUR_USER_ID')
      .then(
        (result) => {
          alert('Message sent successfully!');
        },
        (error) => {
          alert('Failed to send message. Please try again.');
        }
      );

    e.target.reset();
  };

  return (
    <div className="App">
      <header>
        <nav>
          <ul>
            <li><a href="#about">{content.about}</a></li>
            <li><a href="#services">{content.services}</a></li>
            <li><a href="#testimonials">{content.testimonials}</a></li>
            <li><a href="#contact">{content.contact}</a></li>
          </ul>
        </nav>
        <div className="hero-image">
          <img src="spa-hero.jpg" alt="Hero" style={{ width: '100%', height: 'auto' }} />
        </div>
      </header>

      <main>
        <section className="hero" id="about">
          <div className="hero-content">
            <h1>{content.welcome}</h1>
            <p>{content.description}</p>
            <a href="#contact" className="cta-button">{content.contactForm}</a>
          </div>
        </section>

        <section className="section" id="about">
          <h2>{content.about}</h2>
          <p>{content.aboutText}</p>
        </section>

        <section className="section-extended" id="services">
          <h2>{content.servicesOffered}</h2>
          <div className="services-grid">
            <div className="service-card">
              <h3>Massage & Spa Services 💆‍♀️</h3>
              <p>{content.largeScaleDesign}</p>
              <p>{content.problemSolving}</p>
              <p>{content.serverAdmin}</p>
            </div>

            <div className="service-card">
              <h3>Contact & Info 📍</h3>
              <p>{content.phpFrameworks}</p>
              <p>{content.jsFrameworks}</p>
              <p>{content.htmlCss}</p>
              <p>{content.databases}</p>
            </div>
          </div>
        </section>

        <section className="section" id="testimonials">
          <h2>{content.testimonials}</h2>
          <div className="testimonial-grid">
            <div className="testimonial-card">
              <p>{content.Geremew}</p>
              <p className="testimonial-author">- Spa Client</p>
            </div>
            <div className="testimonial-card">
              <p>{content.Basha}</p>
              <p className="testimonial-author">- Regular Customer</p>
            </div>
          </div>
        </section>

        <section className="section" id="contact">
          <h2>{content.contact}</h2>
          <form className="contact-form" onSubmit={sendEmail}>
            <input type="text" name="user_name" placeholder="Your Name" required />
            <input type="email" name="user_email" placeholder="Your Email" required /><br />
            <textarea name="message" placeholder="Your Message" required></textarea><br /><br />
            <button type="submit">Send Message ✉️</button>
          </form>
        </section>
      </main>
    </div>
  );
}

export default App;
